import { Button } from "@mantine/core";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ManagementSearch from "src/components/pages/Management/ManagementSearch/ManagementSearch";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import WelcomeEmailsControls from "src/components/pages/Management/Users/WelcomeEmailsControls";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { type IUser } from "src/components/shared/UserList/UserList.types";
import { useCheckPerm, useGetApi } from "src/hooks";
import { ButtonsWrapper, Flex, PageContainer } from "src/styled";

const mapUsers = (data: any) => {
  let list: IUser[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: IUser) => ({
      ...el,
      active: el.active ? "Yes" : null,
    }));
  }
  return { ...data?.data?.content, list };
};

const Users = () => {
  const checkPerm = useCheckPerm();
  const navigate = useNavigate();

  const requestBody = { _sect: "_users" };

  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: requestBody,
    mapper: mapUsers,
  });

  const handleCreateUser = useCallback(() => {
    navigate("/management/users/create-user");
  }, [navigate]);

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        {/* <Pagination total={1} value={page} onChange={setPage} /> */}
        <ButtonsWrapper>
          {/* <Select
            data={[
              { label: "Active", value: "1" },
              { label: "Inactive", value: "2" },
              { label: "Archived", value: "3" },
            ]}
            value={searchParams.get("status") ?? "1"}
            onChange={value => {
              setSearchParams(prev => {
                prev.set("status", value ?? "1");
                return prev;
              });
            }}
          />
          <TextInput
            placeholder="Search..."
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
          /> */}
          <WelcomeEmailsControls />
          {checkPerm("createuser") && (
            <Button variant="outline" onClick={handleCreateUser}>
              Add +
            </Button>
          )}
        </ButtonsWrapper>
      </Breadcrumbs>
      <Flex justify="end" mt={15}>
        <ManagementSearch
          section="_users"
          refetch={refetch}
          currentRequestParams={requestBody}
        />
      </Flex>
      <ManagementTable
        section="_users"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Users;
